import type { ReactNode } from 'react';
import { MessageCircle } from 'lucide-react';
import { EmptyState } from '@wundo/ui';
import { m } from '@/paraglide/messages.js';

export interface PracticeNotTakenPartProps {
  /** The ways on from here, for a host that has them. */
  actions?: ReactNode;
}

/**
 * A practice the user barely took part in, where the feedback would stand.
 * Nothing was rated, and the words are fixed rather than the model's: a score
 * for a conversation that never happened says nothing.
 */
export function PracticeNotTakenPart({ actions }: PracticeNotTakenPartProps) {
  return (
    <EmptyState
      icon={<MessageCircle />}
      headingLevel='h3'
      title={m.practice_not_taken_part_title()}
      description={m.practice_not_taken_part_body()}
      action={
        actions === undefined ? undefined : (
          <div className='flex flex-wrap items-center justify-center gap-2.5'>
            {actions}
          </div>
        )
      }
    />
  );
}
